var path = 'modules/dcb-eaccount.pages.eadashboard/components/credits.tpl.html';
var html = "<div ng-controller=\"CreditsController as controller\">\n  <div class=\"portlet-body\" ng-class=\"{loading : controller.loading}\">\n    <dc-spinner></dc-spinner>\n    <h3 class=\"plain-heading\">\n      <small data-i18n=\"modules.dashboard.overall\"></small>\n      <br>\n      {{controller.value | money}}\n    </h3>\n  </div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./~/ngtemplate-loader?relativeTo=/src/ui/modules/eaDashboard/components&prefix=modules/dcb-eaccount.pages.eadashboard/components!./~/raw-loader!./src/ui/modules/eaDashboard/components/credits.tpl.html
// module id = 888
// module chunks = 12